<template>
    <div class="nav">
        <div class="navImg">
            <img src="../img/jhlogo.png" alt="">
        </div>

        <!-- 移动端菜单按钮 -->
        <div class="mobile-menu-btn" @click="toggleMobileMenu" v-show="isMobile">
            <span :class="{ active: mobileMenuOpen }"></span>
            <span :class="{ active: mobileMenuOpen }"></span>
            <span :class="{ active: mobileMenuOpen }"></span>
        </div>

        <!-- 移动端菜单覆盖层 -->
        <div class="mobile-menu-overlay" v-show="isMobile && mobileMenuOpen" @click="closeMobileMenu">
            <div class="mobile-menu-content" @click.stop>
                <ul>
                    <li v-for="(item, index) in navList" :key="index"
                        :class="{ active: item.path === $route.path, dropdownOpen: activeIndex === index }">

                        <router-link :to="item.path" v-if="!item.children" @click.native="closeMobileMenu">
                            {{ item.name }}
                        </router-link>

                        <a href="javascript:void(0)" v-else @click="toggleDropdown(index)">
                            {{ item.name }}
                            <i class="arrow-down" :class="{ rotate: activeIndex === index }"></i>
                        </a>

                        <!-- 移动端二级菜单 -->
                        <ul class="dropdown-menu mobile-dropdown" v-show="item.children && activeIndex === index">
                            <li v-for="(child, childIndex) in item.children" :key="childIndex">
                                <router-link :to="child.path" @click.native="closeMobileMenu">{{ child.name
                                }}</router-link>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
        </div>

        <!-- PC端导航列表 -->
        <div class="navList" v-show="!isMobile">
            <ul>
                <li v-for="(item, index) in navList" :key="index"
                    :class="{ active: item.path === $route.path, dropdownOpen: activeIndex === index }">

                    <router-link :to="item.path" v-if="!item.children">
                        {{ item.name }}
                    </router-link>

                    <a href="javascript:void(0)" v-else @click="toggleDropdown(index)">
                        {{ item.name }}
                        <i class="arrow-down" :class="{ rotate: activeIndex === index }"></i>
                    </a>

                    <!-- 二级菜单 - 已改为竖向布局 -->
                    <ul class="dropdown-menu vertical" v-show="item.children && activeIndex === index">
                        <li v-for="(child, childIndex) in item.children" :key="childIndex">
                            <router-link :to="child.path" @click.native="hideAllDropdowns">{{ child.name
                            }}</router-link>
                        </li>
                    </ul>
                </li>
            </ul>
        </div>

        <div class="hqc">
            <div class="earth-trigger" @click="toggleJihuaGroup">
                <img src="../img/earth.png" alt="Earth" class="earth-img">
            </div>

            <div class="jihua-dropdown" :class="{ 'show': showGroup }">
                <div class="jihuaGroup">
                    <div class="GroupBox">
                        <div>
                            <img style="width: 30px; height: 30px;" src="../img/jhlogo1.png" alt="" />
                        </div>
                        <a href="http://www.xxcig.com/" target="_blank">新兴际华集团</a>
                    </div>
                    <div class="GroupBox">
                        <div>
                            <img style="width: 30px; height: 30px;" src="../img/jhlogo1.png" alt="">
                        </div>
                        <a href="http://3502.com/cms/cmsadmin/infopub/indexpre.jsp?pubtype=D&pubpath=jihua&webappcode=A02&templetid=1624753505911941&userId=10002"
                            target="_blank">际华集团股份有限公司</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'daohang',
    data() {
        return {
            activeIndex: -1,
            showGroup: false,
            isMobile: false,
            mobileMenuOpen: false,
            navList: [
                { name: '首页', path: '/' },
                { name: '公司简介', path: '/companyProfile' },
                { name: '资质荣誉', path: '/qualificationHonor' },
                {
                    name: '产品展示',
                    path: '/productDisplay',
                    children: [
                        { name: '环保滤袋', path: '/lvdai' },
                        { name: '环保滤筒', path: '/lvtong' }
                    ]
                },

                { name: '人力资源', path: '/humanResources' },
                { name: '联系我们', path: '/contactUs' },
            ]
        }
    },
    methods: {
        toggleDropdown(index) {
            if (this.activeIndex === index) {
                // 如果点击的是当前已打开的菜单，则关闭它
                this.activeIndex = -1;
            } else {
                // 否则打开点击的菜单
                this.activeIndex = index;
            }
        },
        hideAllDropdowns() {
            this.activeIndex = -1;
        },
        toggleJihuaGroup() {
            this.showGroup = !this.showGroup;
        },
        hideJihuaGroup() {
            this.showGroup = false;
        },
        checkIsMobile() {
            this.isMobile = window.innerWidth <= 768;
            // 如果从移动端切换到PC端，关闭移动菜单
            if (!this.isMobile) {
                this.closeMobileMenu();
            }
        },
        toggleMobileMenu() {
            this.mobileMenuOpen = !this.mobileMenuOpen;
            // 防止背景滚动
            if (this.mobileMenuOpen) {
                document.body.style.overflow = 'hidden';
            } else {
                document.body.style.overflow = '';
            }
        },
        closeMobileMenu() {
            this.mobileMenuOpen = false;
            document.body.style.overflow = '';
            this.hideAllDropdowns();
        }
    },
    mounted() {
        this.checkIsMobile();
        window.addEventListener('resize', this.checkIsMobile);

        // 点击页面其他地方时关闭所有下拉菜单
        document.addEventListener('click', (e) => {
            if (!this.$el.contains(e.target)) {
                this.hideAllDropdowns();
                this.hideJihuaGroup();
            }
        });
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.checkIsMobile);
        document.body.style.overflow = '';
        // 移除事件监听
        document.removeEventListener('click', () => { });
    }
}
</script>

<style scoped lang="scss">
.nav {
    width: 100%;
    height: 60px;
    padding: 10px;
    padding-left: 30px;
    padding-right: 30px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    background-color: rgba(255, 255, 255, 0.7);

    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    // position: absolute;
}

.navImg {
    width: 300px;
    height: 100%;

    img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }
}

.navList {
    flex: 1;
    margin-left: 50px;

    ul {
        list-style: none;
        padding: 0;
        margin: 0;
        display: flex;
        justify-content: flex-end;

        >li {
            position: relative;
            margin-right: 30px;

            a {
                text-decoration: none;
                color: #333;
                font-size: 16px;
                font-weight: 500;
                padding: 20px 15px;
                display: block;
                transition: color 0.3s ease;

                &:hover {
                    // color: #007bff;
                    background-color: #d12b35;
                    color: #fff !important;

                }
            }

            &.active a {
                // color: #007bff;
                color: #7a7777;
            }

            .arrow-down {
                display: inline-block;
                width: 0;
                height: 0;
                border-left: 4px solid transparent;
                border-right: 4px solid transparent;
                border-top: 4px solid currentColor;
                margin-left: 5px;
                transition: transform 0.3s ease;
            }

            .arrow-down.rotate {
                transform: rotate(180deg);
            }

            &.dropdownOpen .arrow-down {
                transform: rotate(180deg);
            }
        }
    }
}

/* 移动端菜单按钮 */
.mobile-menu-btn {
    display: none;
    flex-direction: column;
    cursor: pointer;
    padding: 8px;
    z-index: 1001;

    span {
        width: 25px;
        height: 3px;
        background-color: #333;
        margin: 2px 0;
        transition: 0.3s;
        border-radius: 2px;
        transform-origin: center;


    }


}

/* 移动端菜单覆盖层 */
.mobile-menu-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 999;
    display: flex;
    flex-direction: column;
    animation: fadeIn 0.3s ease;
}

/* 移动端菜单内容 */
.mobile-menu-content {
    position: absolute;
    top: 60px;
    left: 0;
    width: 100%;
    background-color: #fff;
    max-height: calc(100vh - 60px);
    overflow-y: auto;
    animation: slideDown 0.3s ease;

    ul {
        list-style: none;
        padding: 0;
        margin: 0;

        >li {
            position: relative;
            border-bottom: 1px solid #f0f0f0;

            &:last-child {
                border-bottom: none;
            }

            a {
                text-decoration: none;
                color: #333;
                font-size: 16px;
                font-weight: 500;
                padding: 15px 20px;
                display: block;
                transition: all 0.3s ease;

                &:hover {
                    background-color: #f8f9fa;
                    color: #007bff;
                }
            }

            &.active a {
                color: #007bff;
                background-color: #f0f8ff;
            }

            .arrow-down {
                display: inline-block;
                width: 0;
                height: 0;
                border-left: 4px solid transparent;
                border-right: 4px solid transparent;
                border-top: 4px solid currentColor;
                margin-left: 8px;
                transition: transform 0.3s ease;
                float: right;
                margin-top: 8px;
            }

            .arrow-down.rotate {
                transform: rotate(180deg);
            }

            &.dropdownOpen .arrow-down {
                transform: rotate(180deg);
            }
        }
    }
}

/* 移动端二级菜单 */
.dropdown-menu.mobile-dropdown {
    background-color: #f8f9fa;
    border-top: 1px solid #e9ecef;

    li {
        list-style: none;
        border-bottom: 1px solid #e9ecef;

        &:last-child {
            border-bottom: none;
        }

        a {
            padding: 12px 40px;
            font-size: 14px;
            color: #666;
            background-color: #f8f9fa;

            &:hover {
                background-color: #e9ecef;
                color: #007bff;
            }
        }
    }
}

/* 竖向下拉菜单 */
.dropdown-menu.vertical {
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    background-color: #fff;
    min-width: 180px;
    width: max-content;
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
    border-radius: 8px;
    z-index: 1000;
    padding: 8px 0;
    margin-top: 5px;
    border: 1px solid rgba(0, 0, 0, 0.1);

    /* 竖向布局 */
    display: flex;
    flex-direction: column;

    li {
        list-style: none;
        width: 100%;

        a {
            padding: 12px 20px;
            color: #555;
            font-size: 14px;
            text-decoration: none;
            display: block;
            transition: all 0.3s ease;
            border-bottom: 1px solid rgba(0, 0, 0, 0.05);
            text-align: center;

            &:hover {
                background-color: #f8f9fa;
                color: #007bff;
                padding-left: 25px;
            }

            &:last-child {
                border-bottom: none;
            }
        }
    }

    /* 添加小三角形指示器 */
    &::before {
        content: '';
        position: absolute;
        top: -6px;
        left: 50%;
        transform: translateX(-50%);
        width: 0;
        height: 0;
        border-left: 6px solid transparent;
        border-right: 6px solid transparent;
        border-bottom: 6px solid #fff;
        filter: drop-shadow(0 -2px 2px rgba(0, 0, 0, 0.1));
    }
}

/* 水平下拉菜单（保持原有样式，如果需要的话） */
.dropdown-menu:not(.vertical):not(.mobile-dropdown) {
    position: absolute;
    top: 100%;
    left: 0;
    background-color: #fff;
    min-width: 150px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    z-index: 1000;
    padding: 10px 0;

    li {
        list-style: none;

        a {
            padding: 10px 20px;
            color: #666;
            font-size: 14px;
            white-space: nowrap;
            text-align: left;

            &:hover {
                background-color: #f8f9fa;
                color: #007bff;
            }
        }
    }
}

.hqc {
    position: relative;
    display: flex;
    align-items: center;
}

.earth-trigger {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    overflow: hidden;
    cursor: pointer;
    transition: all 0.3s ease;
    border: 2px solid transparent;


    .earth-img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
}

.jihua-dropdown {
    position: absolute;
    top: 100%;
    right: -10px;
    margin-top: 10px;
    background: linear-gradient(135deg, rgba(16, 147, 211, 0.9), rgba(0, 153, 204, 0.9));
    border-radius: 12px;
    padding: 15px;
    min-width: 280px;
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
    opacity: 0;
    visibility: hidden;
    transform: translateY(-10px);
    transition: all 0.3s cubic-bezier(0.68, -0.55, 0.265, 1.55);
    backdrop-filter: blur(10px);
    border: 1px solid rgba(255, 255, 255, 0.2);

    &.show {
        opacity: 1;
        visibility: visible;
        transform: translateY(0);
    }
}

.jihuaGroup {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.GroupBox {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 16px;
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 8px;
    transition: all 0.3s ease;
    cursor: pointer;
    background: rgba(255, 255, 255, 0.1);

    &:hover {
        background: rgba(255, 255, 255, 0.2);
        transform: translateX(5px);
        box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1);
    }
}

.GroupBox>div:first-child {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.GroupBox img {
    width: 20px;
    height: 20px;
    object-fit: contain;
}

.GroupBox a {
    color: white;
    font-size: 14px;
    font-weight: 500;
    text-decoration: none;
    line-height: 1.3;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;
}

.GroupBox:hover a {
    text-shadow: 0 0 5px rgba(255, 255, 255, 0.5);
}

.GroupBox:first-child {
    background: rgba(255, 255, 255, 0.15);
    border: 1px solid rgba(255, 255, 255, 0.25);
}

.GroupBox:first-child:hover {
    background: rgba(255, 255, 255, 0.25);
}

.jihua-dropdown::before {
    content: '';
    position: absolute;
    top: -8px;
    right: 20px;
    width: 0;
    height: 0;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-bottom: 8px solid rgba(16, 147, 211, 0.9);
}

/* 动画效果 */
@keyframes fadeIn {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

@keyframes slideDown {
    from {
        transform: translateY(-20px);
        opacity: 0;
    }

    to {
        transform: translateY(0);
        opacity: 1;
    }
}

/* 平板适配 */
@media (max-width: 1024px) {
    .nav {
        padding-left: 20px;
    }

    .navImg {
        width: 250px;
    }

    .navList {
        margin-left: 30px;
    }

    .navList ul>li {
        margin-right: 20px;
    }

    .navList ul>li a {
        padding: 20px 10px;
        font-size: 15px;
    }
}

/* 移动端适配 */
@media (max-width: 768px) {
    .nav {
        padding-left: 15px;
        justify-content: space-between;
    }

    .navImg {
        width: 180px;
        margin-bottom: 0;
    }

    .mobile-menu-btn {
        display: flex;
    }

    .navList {
        display: none;
    }

    .hqc {
        margin-left: auto;
        margin-right: 10px;
    }

    .jihua-dropdown {
        min-width: 250px;
        right: -50px;
    }

    .dropdown-menu.vertical {
        min-width: 160px;
        left: 0;
        transform: none;

        li a {
            padding: 10px 15px;
            font-size: 13px;
        }
    }

    .jihua-dropdown::before {
        right: 15px;
    }
}

/* 小屏手机适配 */
@media (max-width: 480px) {
    .nav {
        padding: 8px;
    }

    .navImg {
        width: 150px;
    }

    .earth-trigger {
        width: 30px;
        height: 30px;
    }

    .jihua-dropdown {
        min-width: 220px;
        right: -30px;
    }

    .dropdown-menu.vertical {
        min-width: 140px;

        li a {
            padding: 8px 12px;
            font-size: 12px;
        }
    }

    .mobile-menu-btn {
        margin-right: 5px;
        margin-left: 140px;

        span {
            width: 22px;
            height: 2px;
        }
    }

    .mobile-menu-content {
        top: 56px;
        max-height: calc(100vh - 56px);
    }
}

/* 超小屏手机适配 */
@media (max-width: 360px) {
    .navImg {
        width: 120px;
    }

    .jihua-dropdown {
        min-width: 200px;
        right: -20px;
    }

    .jihuaGroup {
        gap: 8px;
    }

    .GroupBox {
        padding: 10px 12px;
    }

    .GroupBox a {
        font-size: 13px;
    }
}
</style>